export default __webpack_public_path__ + "static/ye-ca936d441dac55e9abdc72559a5fa41c.svg";